import { useEffect, useMemo } from 'react';

import { choreographerFactory, ProductIds } from '@atlassian/ipm-choreographer';

import { fg } from '@confluence/feature-gating';

import { getMeta } from './utils/getMeta';
import { determineAnalyticsEnvironment, useAnalyticsEnvironment } from './useAnalyticsEnvironment';

let choreographerServices: ReturnType<typeof choreographerFactory>;
const ajsEnvironment = getMeta('ajs-environment');

if (typeof globalThis.window !== undefined && ajsEnvironment) {
	const environment = determineAnalyticsEnvironment(ajsEnvironment);
	choreographerServices = choreographerFactory(ProductIds.CONFLUENCE, environment);
}

export const useChoreographerServices = () => {
	const analyticsEnv = useAnalyticsEnvironment();
	const choreographerServiceInstance = useMemo(() => {
		if (choreographerServices && fg('confluence_concurrent_choreographer')) {
			// Return module level choreographer services
			return choreographerServices;
		} else if (analyticsEnv) {
			return choreographerFactory(ProductIds.CONFLUENCE, analyticsEnv);
		}
	}, [analyticsEnv]);
	const { plugin } = choreographerServiceInstance ?? {};

	useEffect(() => {
		/**
		 * Cleanup function in case we unmount this component to remount another one.
		 */
		return () => {
			if (plugin) {
				plugin.destroy();
			}
		};
	}, [plugin]);

	return choreographerServiceInstance;
};
